(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["biblioteca-tecnica"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSection(root) {
      if (root.dataset.btInitialized === 'true') return;
      root.dataset.btInitialized = 'true';

      var state = {
        type: 'all',
        collection: new Set(),
        category: new Set(),
        format: new Set(),
        search: ''
      };

      var cards = Array.from(root.querySelectorAll('.bt-card'));
      var typeInputs = Array.from(root.querySelectorAll('[data-bt-type]'));
      var searchInput = root.querySelector('.bt-search');
      var resultCount = root.querySelector('.bt-result-count');
      var activeFiltersWrap = root.querySelector('.bt-active-filters');
      var emptyState = root.querySelector('.bt-empty');
      var sidebar = root.querySelector('[data-bt-filters]');
      var openBtn = root.querySelector('[data-bt-open-filters]');
      var closeBtn = root.querySelector('[data-bt-close-filters]');
      var backdrop = root.querySelector('[data-bt-backdrop]');
      var clearBtn = root.querySelector('[data-bt-clear]');
      var filterInputs = Array.from(root.querySelectorAll('[data-bt-filter]'));
      var detailGroups = Array.from(root.querySelectorAll('[data-bt-group]'));

      function syncGroupsOpen() {
        detailGroups.forEach(function (group) {
          var inputs = Array.from(group.querySelectorAll('input'));
          var hasActive = inputs.some(function (i) { return i.checked; });
          if (hasActive) group.open = true;
        });
      }

      var labels = {
        lourdes: 'Lourdes',
        lourdes_externa: 'Lourdes Externa',
        ps: 'PS',
        portico: 'Pórtico',
        avulsos: 'Avulsos',
        cadeira: 'Cadeiras',
        poltrona: 'Poltronas',
        sofa: 'Sofás',
        banco: 'Bancos',
        mesa_jantar: 'Mesas de jantar',
        mesa_centro_lateral: 'Mesas laterais/centro',
        luminaria: 'Luminárias',
        dwg: 'DWG',
        dxf: 'DXF',
        '3dm': '3DM',
        skp: 'SKP',
        stl: 'STL',
        blend: 'BLEND',
        '3ds': '3DS',
        fbx: 'FBX',
        obj: 'OBJ',
        mtl: 'MTL',
        pdf: 'PDF',
        jpg: 'JPG',
        zip: 'ZIP'
      };

      function applyFilters() {
        var visible = 0;
        for (var i = 0; i < cards.length; i++) {
          var card = cards[i];
          var matchType = state.type === 'all' || card.dataset.type === state.type;
          var matchColl = state.collection.size === 0 || state.collection.has(card.dataset.collection);
          var matchCat = state.category.size === 0 || state.category.has(card.dataset.category);
          var matchFmt = state.format.size === 0 || state.format.has(card.dataset.format);
          var matchSearch = !state.search || (card.dataset.search || '').indexOf(state.search) !== -1;
          var show = matchType && matchColl && matchCat && matchFmt && matchSearch;
          card.classList.toggle('is-hidden', !show);
          if (show) visible++;
        }
        resultCount.textContent = visible + (visible === 1 ? ' resultado' : ' resultados');
        if (emptyState) emptyState.hidden = visible !== 0;
        renderChips();
      }

      function makeChip(groupSet, groupKey, value) {
        var label = labels[value] || value;
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'bt-chip';
        chip.setAttribute('aria-label', 'Remover filtro ' + label);

        var labelNode = document.createTextNode(label);
        chip.appendChild(labelNode);

        var x = document.createElement('span');
        x.className = 'bt-chip-x';
        x.setAttribute('aria-hidden', 'true');
        x.textContent = '×';
        chip.appendChild(x);

        chip.addEventListener('click', function () {
          groupSet.delete(value);
          var selector = '[data-bt-filter="' + groupKey + '"][value="' + value + '"]';
          var input = root.querySelector(selector);
          if (input) input.checked = false;
          applyFilters();
        });
        return chip;
      }

      function renderChips() {
        while (activeFiltersWrap.firstChild) {
          activeFiltersWrap.removeChild(activeFiltersWrap.firstChild);
        }
        var groups = [
          { key: 'collection', set: state.collection },
          { key: 'category', set: state.category },
          { key: 'format', set: state.format }
        ];
        groups.forEach(function (group) {
          group.set.forEach(function (value) {
            activeFiltersWrap.appendChild(makeChip(group.set, group.key, value));
          });
        });
      }

      typeInputs.forEach(function (input) {
        input.addEventListener('change', function () {
          if (input.checked) {
            typeInputs.forEach(function (other) {
              if (other !== input) other.checked = false;
            });
            state.type = input.value;
          } else {
            state.type = 'all';
          }
          applyFilters();
        });
      });

      var searchTimer = null;
      if (searchInput) {
        searchInput.addEventListener('input', function (event) {
          if (searchTimer) clearTimeout(searchTimer);
          searchTimer = setTimeout(function () {
            state.search = event.target.value.toLowerCase().trim();
            applyFilters();
          }, 200);
        });
      }

      filterInputs.forEach(function (input) {
        input.addEventListener('change', function () {
          var bucket = state[input.dataset.btFilter];
          if (!bucket) return;
          if (input.checked) {
            bucket.add(input.value);
            var parentGroup = input.closest('[data-bt-group]');
            if (parentGroup) parentGroup.open = true;
          } else {
            bucket.delete(input.value);
          }
          applyFilters();
        });
      });

      function openSidebar() {
        if (!sidebar) return;
        sidebar.classList.add('is-open');
        if (backdrop) backdrop.hidden = false;
        document.body.style.overflow = 'hidden';
      }

      function closeSidebar() {
        if (!sidebar) return;
        sidebar.classList.remove('is-open');
        if (backdrop) backdrop.hidden = true;
        document.body.style.overflow = '';
      }

      if (openBtn) openBtn.addEventListener('click', openSidebar);
      if (closeBtn) closeBtn.addEventListener('click', closeSidebar);
      if (backdrop) backdrop.addEventListener('click', closeSidebar);

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && sidebar && sidebar.classList.contains('is-open')) {
          closeSidebar();
        }
      });

      if (clearBtn) {
        clearBtn.addEventListener('click', function () {
          state.collection.clear();
          state.category.clear();
          state.format.clear();
          state.type = 'all';
          filterInputs.forEach(function (input) { input.checked = false; });
          typeInputs.forEach(function (input) { input.checked = false; });
          detailGroups.forEach(function (group) { group.open = false; });
          applyFilters();
        });
      }

      syncGroupsOpen();
      applyFilters();
    }

    function initAll() {
      var sections = document.querySelectorAll('[data-bt-section]');
      sections.forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.querySelector('[data-bt-section]');
      if (section) initSection(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
